export default {
  usernameToUserInfo (state) {
    let result = {}
    for (let item of state.dataUserList) {
      result[item.username] = item
    }
    return result
  }
}



// WEBPACK FOOTER //
// ./src/store/getters.js